import { render, staticRenderFns } from "./AnythingGoes.vue?vue&type=template&id=1b4645e3&scoped=true"
import script from "./AnythingGoes.vue?vue&type=script&lang=js"
export * from "./AnythingGoes.vue?vue&type=script&lang=js"
import style0 from "./AnythingGoes.vue?vue&type=style&index=0&id=1b4645e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4645e3",
  null
  
)

export default component.exports